<template>
	<div v-show="printJS" id="printJS-form" style="border:1px solid #000000;width: 300px;">
		<div  style="
        text-align: center;
        font-size: 24px;
        font-weight: 500;
        color: #000000;">
        送貨專綫
		</div>
		
		<div style="border-bottom: 2px dashed #000000;">
		</div>
		
		<div style="margin-left:18px; ;">
        <span style="
        font-size: 28px;
        color: #141A2B;
       ">{{ form.userName }}</span>
		</div>
		
		<div style="margin-left:18px; ;">
        <span style="
        font-size: 18px;
        font-weight: 500;
        color: #000000;
       ">{{ form.userPhone }}</span>
		</div>
		
		<div style="margin:5px 0 6px 0;border-bottom: 2px dashed #000000;"></div>
		
		
		<div style="text-align: center;">
			<img style="width: 120px; height:120px;"
			     :src="qrcode"
			     alt="" srcset="">
		</div>
		
		<div style="
    margin-top: 4px;
    margin-bottom: 4px;
    font-size: 18px;
    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
    color: #000000;
    text-align: center;">
			数量：{{ form.ordernum }}
		</div>
		
		
		<div style="border-bottom: 2px dashed #000000;"></div>
		<div style="font-size:13px;padding: 6px;line-height: 20px;">{{ form.order }}</div>
		<div style="border-bottom: 2px dashed #000000;"></div>
		
		<div style="margin-left:18px;">
        <span style="width: 28px;
        font-size: 14px;
        color: #000000;
       ">單號</span>
			<span style="width: 28px;
        font-size: 14px;
        color: #000000;margin-left: 70px;
        ">貨架號</span>
		</div>
		<div style="margin-left:16px;">
			<div style="width: 210px;height: 21px;font-size: 14px;color: #000000;"
			     v-for="(item,index) in form.orders" :key="index">
				<span>****{{  filterOrder(item.order) }}</span>
				<span style="margin-left: 35px;">{{ item.shelf }}</span>
			</div>
			
		</div>
		<div style="border-bottom: 2px dashed #000000;"></div>
		
		<div style="margin-left:18px;">
        <span style="width: 200px;
        font-size: 14px;
        color: #000000;
       ">快递费</span>
			<span style="width: 100px;
        font-size: 14px;
        color: #000000;margin-left: 80px;
        ">{{ form.amount }}</span>
		</div>
		
		<div style="margin-left:18px;">
        <span style="width: 200px;
        font-size: 14px;
        color: #000000;
       ">送貨費</span>
			<span style="width: 100px;
        font-size: 14px;
        color: #000000;margin-left: 80px;
        "></span>
		</div>
		
		<div style="margin:5px 0 6px 0;border-bottom: 2px dashed #000000;"></div>
		
		<div>
        <span style="font-size: 14px;
        color: #000000;margin-left: 10px;
       ">(用戶在綫支付)</span> {{ form.amount }}
		</div>
		
		
		<div style="margin:5px 0 6px 0;border-bottom: 2px dashed #000000;"></div>
		
		<div style="margin-left:18px;">
        <span style="width: 216px;
        height: 17px;
        font-size: 12px;
        color: #141A2B;
       ">派送時間：{{ form.order_reserve_time }}</span>
		</div>
		
		<div style="margin:5px 0 6px 0;border-bottom: 2px dashed #000000;"></div>
		
		<div style="padding: 0 6px;">
        <span style="
        font-size: 28px;
        font-weight: 500;
        color: #000000;
       ">
           {{ form.deliveryName }}
        </span>
		
		</div>
	</div>
</template>

<script>
import QRCode from "qrcode";
import print from 'print-js'

export default {
	name: "PrintInCode2",
	data() {
		return {
			print_ref: null,
			form: {
				orders: [],
				userPhone: "",
				userName: "",
				areaName: "",
				deliveryName: "",
				amount: "",
				order_reserve_time: "",
				ordernum: "",
				order: "",
			},
			qrcode: '',
			printJS: false
		}
	},
	created() {
	
	},
	mounted() {
	
	},
	methods: {
		filterOrder(order) {
			if (!order || order?.length < 5) return ''
			return order.slice(order.length-4)
		},
		convertImgToBase64(url, callback, outputFormat) {
			let canvas = document.createElement('CANVAS'),
					ctx = canvas.getContext('2d'),
					img = new Image;
			img.crossOrigin = 'Anonymous';
			img.onload = function () {
				canvas.height = img.height;
				canvas.width = img.width;
				ctx.drawImage(img, 0, 0);
				const dataURL = canvas.toDataURL(outputFormat || 'image/png');
				callback.call(this, dataURL);
				canvas = null;
			};
			img.src = url;
		},
		async generateQR(text) {
			try {
				return await QRCode.toDataURL(text, {
					margin: 0,
					quality: 1
				})
			} catch (err) {
				this.$Message.error('打印二维码生成失败，请重试')
				console.error(err)
			}
		},
		printCode(order_flows, cb) {
			console.log(order_flows)
			
			this.$Rq.requestAuth({
				url: this.$Api.deliverCode5,
				method: 'get',
				data: {
					order_flows: order_flows,
				},
			}).then(async res => {
				console.log(res)
				if (!res.order) {
					cb('error')
					return this.$Message.error('订单信息错误')
				}
				this.form = res;
				this.qrcode = await this.generateQR(res.order)
				console.log(this.qrcode)
				this.printJS = true
				this.$nextTick(() => {
					try {
						
						printJS({
							printable: 'printJS-form',
							type: 'html',
							targetStyles: ['*'],
							maxWidth: '800px'
						})
						cb('yes')
					} catch (e) {
						cb('error')
					} finally {
						this.printJS = false
					}
					
				})
			})
		}
	}
}
</script>

<style scoped>

</style>
